/* !
 * jQuery feature v1.0.0
 * Copyright 2018, Connecty Inc.
 */
(function($, MIKI){
	// ＜FEATURE詳細＞おすすめ記事取得
	const getJSONRecommend = (_param) => {
		return $.getJSON(`/ajax/feature_list.json?${_param}`);
	};
	const setRecommend = () => {
		let param = '';
		$('.news-detail-head-tags .cf_n_tags').each((idx, ele) => {
			// 空のタグは見えなくする
			if($(ele).find('span').text() === '') {
				$(ele).addClass('di_none');
			}

			param += `cat=${$(ele).find('span').attr('data-key')}&`;
		});
		param = param.slice(0, -1);

		getJSONRecommend(param).then((data) => {
			if(data.rt_bn_feature_list.length) {
				const thisID = MIKI.va.pathname.split('/')[2].replace(/\.html/, '');
				const thisDate = new Date();
				let recoHTML = '';
				for(let i=0; i<data.rt_bn_feature_list.length; i++) {
					if(thisID !== data.rt_bn_feature_list[i]._key) {
						let href = `<a href="/feature/${data.rt_bn_feature_list[i]._key}.html" class="mod-boxLink01-item">`;

						// 添付ファイルの場合
						if(data.rt_bn_feature_list[i].cf_n_type === 2) {
							href = `<a href="/news/news_file/file/${data.rt_bn_feature_list[i].cf_n_attachment_file}" target="_blank" class="mod-boxLink01-item">`;
						}
						// URL指定の場合
						if(data.rt_bn_feature_list[i].cf_n_type === 3) {
							href = `<a href="${data.rt_bn_feature_list[i].cf_n_url}" target="_blank" class="mod-boxLink01-item">`;
						}
						if(data.rt_bn_feature_list[i].cf_n_type === 5) {
							href = '<a href="" class="mod-boxLink01-item" style="pointer-events:none; cursor:default; text-decoration:none;">';
						}

						recoHTML +=
						'<div class="pure-u-1-4 pure-u-lg-1-2 space-u-20-child">'+
						href +
						`<img src="/news/news_file/file/${data.rt_bn_feature_list[i].cf_n_thum_img.replace(/ /g, '%20')}">`+
						`<p class="mod-boxLink01-title">${data.rt_bn_feature_list[i].cf_n_title}</p>`;

						let thisFeatDate = new Date(data.rt_bn_feature_list[i].cf_n_date);
						recoHTML +=
						'<time class="mod-boxLink01-date">'+
						`${thisFeatDate.getFullYear()}.${('0'+String(thisFeatDate.getMonth()+1)).slice(-2)}.${('0'+String(thisFeatDate.getDate())).slice(-2)}`+
						'</time>';

						// 7日以内ならNEW
						if(Math.ceil((thisDate - thisFeatDate) / 86400000) <= 7) {
							recoHTML += '&nbsp;<span class="mod-boxLink01-new">NEW</span>';
						}
						recoHTML += '</a></div>';
					}
				}
				$('.js-recommend').append(recoHTML);
			}
		});
	};

	// ＜FEATURE詳細＞JSONLD出力
	const setJsonLD = () => {
		const domain = 'https://www.paris-miki.co.jp';
		let appendSrc =
			'{"@context": "http://schema.org/", "@type": "Article", ' +
			`"mainEntityOfPage": { "@type": "WebPage", "@id": "${domain}${location.pathname}"},` +
			`"headline": "${$('.mod-head01-inner').text()}",` +
			`"description": "${$('.rt_meta_description').eq(0).attr('content')}",` +
			`"image": "${domain}${$('.contents').find('.rt_cf_it_image_file').eq(0).attr('src')}",` +
			'"publisher": { "@type": "Organization", "name": "株式会社パリミキ",' +
			`"url": "${domain}/",` +
			`"logo": { "@type": "ImageObject", "url": "${domain}/common/images/logo.svg"}},` +
			`"datePublished": "${$('.rt_cf_n_date').text()}",`;

		if ($('.rt_cf_n_update_date').length) {
			appendSrc += `"dateModified": "${$('.rt_cf_n_update_date').text().replace(/　更新日：/, '')}"}`;
		} else {
			appendSrc += `"dateModified": "${$('.rt_cf_n_date').text()}"}`;
		}

		$('.jsonld-script').append(appendSrc);
	};

	setRecommend();
	setJsonLD();

})(window.jQuery, window.MIKI);
